import { render, staticRenderFns } from "./bzzx.vue?vue&type=template&id=eaa0f764&scoped=true&"
import script from "./bzzx.vue?vue&type=script&lang=js&"
export * from "./bzzx.vue?vue&type=script&lang=js&"
import style0 from "./bzzx.vue?vue&type=style&index=0&id=eaa0f764&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaa0f764",
  null
  
)

component.options.__file = "bzzx.vue"
export default component.exports